import { CTA } from '@r-and-a-shared-ui/common-ui';
import SimplePopUp from '@r-and-a-shared-ui/common-ui/src/lib/SimplePopUp/SimplePopUp';
import {
  COLOR_DARK_BLUE_PRIMARY,
  COLOR_PP_INPUT_OUTLINE,
  COLOR_WATER_DARK,
  COLOR_WHITE,
} from '@r-and-a-shared-ui/utils';

import styles from './ConfirmationDialog.module.scss';

export const ConfirmationDialog = (props: any) => {
  const { isDialogOpen, onConfirm, onClose } = props;

  return (
    <SimplePopUp
      isVisible={isDialogOpen}
      onClose={onClose}
      inlineStyle={{ width: 'auto' }}
    >
      <div className={styles['confirmation-dialog']}>
        <div className={styles['confirmation-dialog__content']}>
          <p>
            Are you sure you want to exit? <br />
            All unsaved changes will be lost.
          </p>
          <div className={styles['confirmation-dialog__buttons']}>
            <CTA onClick={onConfirm} label="Yes" />
            <CTA
              onClick={onClose}
              label="No"
              backgroundColor={COLOR_WHITE}
              borderColor={COLOR_PP_INPUT_OUTLINE}
              textColor={COLOR_DARK_BLUE_PRIMARY}
            />
          </div>
        </div>
      </div>
    </SimplePopUp>
  );
};
